<template>
  <vs-popup
    :title="getTitle()"
    :active.sync="showThisPopup"
    @close="handleClose"
    v-if="
      hasPermissionForActiveVenue(
        'vp.vp.booking.createbookings'
      )
    "
    class="add-booking-popup"
  >
    <editing-booking
      ref="editingBookingComponent"
      :venue-details="venueDetails"
      @booking-saved="handleBookingSaved"
      :editing-mode="EDITING_MODE.Create"
    />
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import EditingBooking, {EDITING_MODE} from "./components/EditingBooking/EditingBooking.vue";

export default {
  components: {
    EditingBooking,
  },
  props: {
    venueDetails: Object,
  },
  data() {
    return {
      EDITING_MODE,
      showThisPopup: false,
    };
  },
  computed: {},
  methods: {
    async show(isWalkIn, date) {
      this.isWalkIn = isWalkIn;
      this.$refs.editingBookingComponent.createBooking(isWalkIn, date);

      this.showThisPopup = true;
    },

    async showWithTable(date, setup, section, table) {
      this.isWalkIn = false;
      this.$refs.editingBookingComponent.createBookingWithTable(this.isWalkIn, date, setup, section, table);

      this.showThisPopup = true;
    },
    getTitle() {
      return this.isWalkIn ? "Create new Walk-In" : "Create new Booking";
    },
    handleBookingSaved() {
      this.$emit("booking-created");
      this.handleClose();
    },
    handleClose() {
      this.$refs.editingBookingComponent.clear();
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-booking-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;
  }
}

.booking-section {
  background: #f8f8f8;
}

.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}
</style>
